import { ArrowRight } from 'lucide-react';
import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { STORE_PATH } from '@/shared/config';

interface QuoteGuideHeroProps {
  /** "내 디자인으로 견적 요청" 섹션의 id — 보조 버튼이 같은 화면 안에서 그리로 내려간다. */
  readonly designsSectionId: string;
}

/**
 * 견적문의 첫 화면 — 큰 영문 "Quote" 제목(보조기기에는 "견적문의")과 한 줄 안내, 두 갈래 버튼.
 * 디자인 없는 견적 요청은 범위 밖이라(견적 설계 §17) 버튼은 디자인 시작과 저장한 디자인으로만 이끈다.
 */
export const QuoteGuideHero = ({ designsSectionId }: QuoteGuideHeroProps): ReactElement => (
  <section aria-labelledby="quote-guide-heading">
    <header className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between lg:gap-16">
      <div className="flex flex-col gap-6">
        <p className="flex items-center gap-3 text-[13px] font-semibold tracking-[0.18em] text-muted-foreground">
          <span aria-hidden className="block h-px w-10 bg-brand-lime" />
          QUOTE REQUEST
        </p>
        <h1
          id="quote-guide-heading"
          className="text-[clamp(2.5rem,5vw,4.5rem)] leading-none font-bold tracking-[-0.03em]"
        >
          <span aria-hidden>Quote</span>
          <span className="sr-only">견적문의</span>
        </h1>
        <p className="max-w-2xl text-[clamp(1.375rem,2.4vw,2rem)] leading-[1.35] font-semibold tracking-[-0.03em] text-balance">
          디자인을 만들고 바로 견적을 요청하세요. 확정견적은 담당자가 확인 후 보내 드립니다.
        </p>
      </div>

      <div className="flex flex-col gap-3 sm:flex-row lg:shrink-0 lg:pb-2">
        <Link
          to={STORE_PATH}
          className="inline-flex h-13 items-center justify-center gap-2 rounded-full bg-primary px-7 text-[15px] font-semibold text-primary-foreground transition-opacity hover:opacity-90"
        >
          디자인 시작하기
          <ArrowRight aria-hidden strokeWidth={1.75} className="size-4" />
        </Link>
        <a
          href={`#${designsSectionId}`}
          className="inline-flex h-13 items-center justify-center rounded-full border border-foreground px-7 text-[15px] font-semibold transition-colors hover:bg-foreground hover:text-background"
        >
          내 디자인으로 요청
        </a>
      </div>
    </header>
  </section>
);
